export default __webpack_public_path__ + "static/media/Brainstorm.bd8d6eb2.webp";